import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectCards } from "swiper/modules";
import axios from "axios";
import API from "../../api/api";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-cards";
import apisecured from "../../api/apisecured";

const HomeCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fallback testimonial data in case API fails
  const fallbackTestimonials = [
    {
      uid: "fallback-1",
      imageUrl: "/path/to/fallback-image1.jpg", // Replace with your fallback images
      profileUrl: "#",
      author: "@RORO",
      text: "SPONSA was a breeze to set up! Having full access to the tips as the goals are underway is a total game anger for the streaming scene!",
    },
    {
      uid: "fallback-2",
      imageUrl: "/path/to/fallback-image2.jpg",
      profileUrl: "#",
      author: "@StreamerPro",
      text: "The goal tracking feature keeps my community engaged and motivated to support my streaming journey!",
    },
  ];

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        setLoading(true);
        const response = await apisecured.get(
          `${API}account/testimonial/getall`
        );
        if (response.data && response.data.length > 0) {
          const mappedTestimonials = response.data.map(
            (testimonial, index) => ({
              ...testimonial,
              author: `@User${index + 1}`, // Placeholder author
              text: "Amazing experience with SPONSA! Highly recommend to all streamers.", // Placeholder text
            })
          );
          setTestimonials(mappedTestimonials);
        } else {
          setTestimonials(fallbackTestimonials);
        }
        setError(null);
      } catch (err) {
        console.error("Error fetching testimonials:", err);
        setError("Failed to load testimonials");
        setTestimonials(fallbackTestimonials);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, []);

  const handleImageClick = (profileUrl) => {
    if (profileUrl && profileUrl !== "#") {
      window.open(profileUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleImageError = (e) => {
    e.target.src = "/path/to/default-testimonial-image.jpg";
  };

  if (loading) {
    return (
      <div className="relative w-full max-w-[1160px] mx-auto px-4 flex items-center justify-center h-[380px] md:h-[520px]">
        <div className="text-white text-xl">Loading testimonials...</div>
      </div>
    );
  }

  if (error && testimonials.length === 0) {
    return (
      <div className="relative w-full max-w-[1160px] mx-auto px-4 flex items-center justify-center h-[380px] md:h-[520px]">
        <div className="text-red-400 text-xl">{error}</div>
      </div>
    );
  }

  return (
    <div className="relative w-full max-w-[1160px] mx-auto px-4">
      <Swiper
        modules={[Pagination, Autoplay, EffectCards]}
        effect="cards"
        loop={true}
        grabCursor={true}
        cardsEffect={{
          slideShadows: true,
          transformEl: null,
          perSlideOffset: 8,
        }}
        pagination={{
          el: ".custom-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return `<div class="${className} custom-bullet" data-index="${index}"></div>`;
          },
        }}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        className="w-full max-w-[1160px]"
        style={{ aspectRatio: "16 / 9" }}
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide
            key={testimonial.uid || `testimonial-${index}`}
            className="rounded-[19px] [box-shadow:0px_4px_10px_10px_#000000CC] w-[900px] h-[506px] relative overflow-hidden group"
          >
            <img
              src={testimonial.imageUrl}
              alt={`Testimonial from ${testimonial.author || "User"}`}
              className="relative z-[0] w-full h-full object-cover md:rounded-[20px] rounded-[10px] transition-transform duration-700 ease-out group-hover:scale-105 cursor-pointer"
              onClick={() => handleImageClick(testimonial.profileUrl)}
              onError={handleImageError}
            />

            <div
              className="absolute inset-0 z-[1] cursor-pointer"
              onClick={() => handleImageClick(testimonial.profileUrl)}
            />

            {/* Content Layout */}
            {/* <div className="flex-1 p-8 absolute md:bottom-4 sm:bottom-2 bottom-1 md:right-4 sm:right-2 right-1 z-10">
              <div className="max-w-[546px] md:rounded-[20px] rounded-[10px] overflow-hidden bg-[linear-gradient(180deg,_#00FF8F_0%,_#33B4FF_100%)] md:p-[10px] p-[4px]">
                <div className="bg-[#030021] md:rounded-[20px] rounded-[10px] overflow-hidden md:p-10 p-4 space-x-1 font-bold md:text-[24px] sm:text-[16px] text-[14px] leading-[100%] tracking-[0%] italic text-center">
                  <span className="text-green-400 mb-2">
                    {testimonial.author || "@User"}:
                  </span>
                  <span className="text-white italic">
                    "{testimonial.text || "Amazing experience with SPONSA!"}"
                  </span>
                </div>
              </div>
            </div> */}
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Pagination - positioned at the bottom center */}
      <div className="custom-pagination flex justify-center items-center space-x-2 mt-6"></div>

      {/* Custom Styles for pagination */}
      <style jsx>{`
        .custom-bullet {
          width: 7px;
          height: 7px;
          background: #d9d9d9;
          border-radius: 50%;
          transition: all 0.3s ease;
          cursor: pointer;
          opacity: 1;
        }

        .custom-bullet:hover {
          background: rgba(217, 217, 217, 0.6);
        }

        .custom-bullet.swiper-pagination-bullet-active {
          width: 30px;
          height: 7px;
          background: linear-gradient(90deg, #00ff8f 0%, #33b4ff 100%);
          border-radius: 6px;
          box-shadow: 0 2px 8px rgba(34, 197, 94, 0.3);
        }

        /* Override default Swiper pagination styles */
        .swiper-pagination-bullet {
          opacity: 1 !important;
        }

        /* Card stack effect styling */
        .swiper-cards .swiper-slide {
          border-radius: 1rem;
        }
      `}</style>
    </div>
  );
};

export default HomeCarousel;
